import React, { createContext, useContext, useState, useEffect } from 'react';
import CONFIG from '../CONFIG.json';

const DEFAULT_ROSALES = {
  id: 'rosales',
  nombre: 'Spa Rosales',
  sufijo: 'rosales_'
};

const DEFAULT_LAGASCA = {
  id: 'lagasca',
  nombre: 'Spa Lagasca',
  sufijo: 'lagasca_'
};

const CentroContext = createContext({
  centro: DEFAULT_ROSALES,
  loading: true,
  setCentro: () => {}
});

export const CentroProvider = ({ children }) => {
  const detectInitialCentro = () => {
    if (typeof window === 'undefined') return DEFAULT_ROSALES;

    // 1. Revisar si hay un parámetro ?centro=lagasca en la URL
    const params = new URLSearchParams(window.location.search);
    const urlCentro = params.get('centro') || params.get('centroId');
    if (urlCentro) {
      const clean = urlCentro.toLowerCase();
      sessionStorage.setItem('preferred_centro_id', clean);
      return clean === 'lagasca' ? DEFAULT_LAGASCA : DEFAULT_ROSALES;
    }

    // 2. Revisar si se guardó en sessionStorage para desarrollo local
    const savedCentro = sessionStorage.getItem('preferred_centro_id');
    if (savedCentro) {
      return savedCentro === 'lagasca' ? DEFAULT_LAGASCA : DEFAULT_ROSALES;
    }

    // 3. Revisar por dominio / hostname
    const host = window.location.hostname.toLowerCase();
    if (host.includes('lagasca')) {
      return DEFAULT_LAGASCA;
    }

    return DEFAULT_ROSALES;
  };

  const [centro, setCentro] = useState(detectInitialCentro);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCentroInfo = async () => {
      try {
        const savedCentro = typeof window !== 'undefined' ? sessionStorage.getItem('preferred_centro_id') : null;
        const url = `${CONFIG.api}centro-info${savedCentro ? `?centro=${savedCentro}` : ''}`;
        
        const res = await fetch(url);
        const json = await res.json();
        if (isMounted && json && json.error === 0 && json.data) {
          const nextCentro = {
            id: json.data.id || 'rosales',
            nombre: json.data.nombre || 'Spa Rosales',
            sufijo: json.data.sufijo || 'rosales_'
          };
          setCentro(nextCentro);
          if (typeof document !== 'undefined') {
            document.title = nextCentro.nombre;
          }
        }
      } catch (e) {
        console.warn('No se pudo conectar a /api/centro-info, usando detección por hostname:', e);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchCentroInfo();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined' && centro && centro.nombre) {
      document.title = centro.nombre;
    }
  }, [centro]);

  return (
    <CentroContext.Provider value={{ centro, loading, setCentro }}>
      {children}
    </CentroContext.Provider>
  );
};

export const useCentro = () => useContext(CentroContext);

export default CentroContext;
